import { WidgetPreference } from '../../types/state';
import { HOME_WIDGET_PREFERENCES } from '../../constants/endpoints';
import request from '../request';

export interface WidgetPreferencesResponse {
  homeUserPreferences: WidgetPreference[];
}

export const fetchWidgetPreferences =
  async (): Promise<WidgetPreferencesResponse> => {
    const { data } = await request({
      method: 'get',
      url: HOME_WIDGET_PREFERENCES(),
    });
    return data as WidgetPreferencesResponse;
  };

export const patchWidgetPreference = async (
  widgetId: string,
  isHidden: boolean
): Promise<void> => {
  await request({
    method: 'patch',
    url: `${HOME_WIDGET_PREFERENCES()}/${widgetId}`,
    data: { isHidden },
  });
};
